module.exports = __webpack_public_path__ + "assets/images/plannerFlattenElevation-88b3198fc2b42cee2685984fd39bca8c.gif";